export const ACCOUNT_PLAN = ['REGULAR', 'PREMIUM'];

export const TENANT_USER_ROLES = ['DISPATCHER', 'ACCOUNTANT', 'ADMIN'];

export const USER_PERMISSIONS = [
  {
    component: 'ORDER', options: [{ label: 'All', value: 'ORDER_ALL' }, { label: 'Add or Edit', value: 'ORDER_WRITE' },
      { label: 'Delete', value: 'ORDER_DELETE' }, { label: 'Only View', value: 'ORDER_READ' }]
  },
  {
    component: 'BROKER', options: [{ label: 'All', value: 'BROKER_ALL' }, { label: 'Add or Edit', value: 'BROKER_WRITE' },
      { label: 'Delete', value: 'BROKER_DELETE' }, { label: 'Only View', value: 'BROKER_READ' }]
  },
  {
    component: 'COMPANY', options: [{ label: 'All', value: 'COMPANY_ALL' }, { label: 'Add or Edit', value: 'COMPANY_WRITE' },
      { label: 'Delete', value: 'COMPANY_DELETE' }, { label: 'Only View', value: 'COMPANY_READ' }]
  },
  {
    component: 'DRIVER', options: [{ label: 'All', value: 'DRIVER_ALL' }, { label: 'Add or Edit', value: 'DRIVER_WRITE' },
      { label: 'Delete', value: 'DRIVER_DELETE' }, { label: 'Only View', value: 'DRIVER_READ' }]
  },
  {
    component: 'ASSETS', options: [{ label: 'All', value: 'ASSETS_ALL' }, { label: 'Add or Edit', value: 'ASSETS_WRITE' },
      { label: 'Delete', value: 'ASSETS_DELETE' }, { label: 'Only View', value: 'ASSETS_READ' }]
  },
  {
    component: 'INVOICE', options: [{ label: 'All', value: 'INVOICE_ALL' }, { label: 'Add or Edit', value: 'INVOICE_WRITE' },
      { label: 'Delete', value: 'INVOICE_DELETE' }, { label: 'Only View', value: 'INVOICE_READ' }]
  },
  {
    component: 'DRIVER SETTLEMENT', options: [{ label: 'All', value: 'DRIVER_SETTLEMENT_ALL' }, { label: 'Add or Edit', value: 'DRIVER_SETTLEMENT_WRITE' },
      { label: 'Delete', value: 'DRIVER_SETTLEMENT_DELETE' }, { label: 'Only View', value: 'DRIVER_SETTLEMENT_READ' }]
  },
  {
    component: 'OPERATIONAL EXPENSES', options: [{ label: 'All', value: 'OPERATIONAL_EXPENSES_ALL' }, { label: 'Add or Edit', value: 'OPERATIONAL_EXPENSES_WRITE' },
      { label: 'Delete', value: 'OPERATIONAL_EXPENSES_DELETE' }, { label: 'Only View', value: 'OPERATIONAL_EXPENSES_READ' }]
  },
  {
    component: 'SETTINGS', options: [{ label: 'All', value: 'SETTINGS_ALL' }, { label: 'Add or Edit', value: 'SETTINGS_WRITE' },
      { label: 'Only View', value: 'SETTINGS_READ' }]
  },
  { component: 'REPORT', options: [{ label: 'View', value: 'REPORT_READ' }] }
];

export const DEFAULT_PERMISSIONS_BY_ROLE = {
  'ADMIN': ['ORDER_ALL', 'BROKER_ALL', 'COMPANY_ALL', 'DRIVER_ALL', 'ASSETS_ALL', 'INVOICE_ALL', 'DRIVER_SETTLEMENT_ALL', 'OPERATIONAL_EXPENSES_ALL', 'SETTINGS_ALL', 'REPORT_READ'],
  'DISPATCHER': ['ORDER_ALL', 'BROKER_ALL', 'COMPANY_ALL', 'DRIVER_ALL', 'ASSETS_ALL', 'INVOICE_READ', 'DRIVER_SETTLEMENT_READ', 'OPERATIONAL_EXPENSES_ALL', 'SETTINGS_ALL', 'REPORT_READ'],
  'ACCOUNTANT': ['ORDER_READ', 'BROKER_READ', 'COMPANY_READ', 'DRIVER_READ', 'ASSETS_READ', 'INVOICE_ALL', 'DRIVER_SETTLEMENT_ALL', 'OPERATIONAL_EXPENSES_ALL', 'SETTINGS_ALL', 'REPORT_READ'],
};

export const ORDER_API_PARAMS = ['TODAY', 'CUSTOM', 'ALL', 'NO-APPOINTMENT'];
export const ORDER_TYPE = ['DELIVERY', 'PICKUP', 'DROP', 'DROP_PICK'];
export const LOAD_TYPE_MAPPING = {'TRUCKLOAD':'TRUCKLOAD',
  // 'LESS THAN TRUCKLOAD': 'LESS_THAN_TRUCKLOAD', 
  'DROP AND HOOK':'DROP_AND_HOOK'
};
export const EQUIPMENT_MAPPING = {
  'VAN': 'VAN',
  'REEFER': 'REEFER',
  'POWER ONLY': 'POWER_ONLY',
  'FLATBED': 'FLATBED',
  'ANIMAL CARRIER': 'ANIMAL_CARRIER',
  'CARGO VAN': 'CARGO_VAN',
  'BOX TRUCK': 'BOX_TRUCK',
  'SPRINTER':'SPRINTER',
  'DUMP TRUCK': 'DUMP_TRUCK'
};

export const PAYMENT_MODE = { 'ACH': 'ACH', 'CHECK': 'CHECK', 'CREDIT CARD': 'CREDIT_CARD', 'DIRECT DEPOSIT': 'DIRECT_DEPOSIT', 'OTHERS': 'OTHERS' };
export const LEG_TYPE_MAPPING =
{
  'TTC': 'Terminal->Consignee',
  'TTY': 'Terminal->Yard',
  'YTC': 'Yard->Consignee',
  'CTY': 'Consignee->Yard',
  'CTT': 'Consignee->Terminal',
  'YTT': 'Yard->Terminal',
  'STT': 'Shipper->Terminal',
  'STY': 'Shipper->Yard',
  'TTCTT': 'Terminal->Consignee->Terminal',
  'TTCTY': 'Terminal->Consignee->Yard',
  'YTCTT': 'Yard->Consignee->Terminal',
  'YTCTY': 'Yard->Consignee->Yard'
};

export const EXPENSE_TYPE = ['BILLABLE', 'NON_BILLABLE'];
export const BOOLEAN_OPTION = ['YES', 'NO'];
export const DRIVER_CHARGES_STATUS = ['NEW', 'APPROVED', 'NOT_APPROVED'];

/* USA, Canada, Australia, NewZealand, UK, India*/

/* USA, Canada, Australia, NewZealand, UK, India, Mexico */
export const COUNTRY_DATA = [
  {
    code: 'US',
    name: 'United States',
    stateNameCodeMap: {
      'Alabama': 'AL',
      'Alaska': 'AK',
      'Arizona': 'AZ',
      'Arkansas': 'AR',
      'California': 'CA',
      'Colorado': 'CO',
      'Connecticut': 'CT',
      'Delaware': 'DE',
      'Florida': 'FL',
      'Georgia': 'GA',
      'Hawaii': 'HI',
      'Idaho': 'ID',
      'Illinois': 'IL',
      'Indiana': 'IN',
      'Iowa': 'IA',
      'Kansas': 'KS',
      'Kentucky': 'KY',
      'Louisiana': 'LA',
      'Maine': 'ME',
      'Maryland': 'MD',
      'Massachusetts': 'MA',
      'Michigan': 'MI',
      'Minnesota': 'MN',
      'Mississippi': 'MS',
      'Missouri': 'MO',
      'Montana': 'MT',
      'Nebraska': 'NE',
      'Nevada': 'NV',
      'New Hampshire': 'NH',
      'New Jersey': 'NJ',
      'New Mexico': 'NM',
      'New York': 'NY',
      'North Carolina': 'NC',
      'North Dakota': 'ND',
      'Ohio': 'OH',
      'Oklahoma': 'OK',
      'Oregon': 'OR',
      'Pennsylvania': 'PA',
      'Rhode Island': 'RI',
      'South Carolina': 'SC',
      'South Dakota': 'SD',
      'Tennessee': 'TN',
      'Texas': 'TX',
      'Utah': 'UT',
      'Vermont': 'VT',
      'Virginia': 'VA',
      'Washington': 'WA',
      'West Virginia': 'WV',
      'Wisconsin': 'WI'
    }
  },
  {
    code: 'USA',
    name: 'United States',
  },
  {
    code: 'CA',
    name: 'Canada',
    stateNameCodeMap: {
      'Alberta': 'AB',
      'British Columbia': 'BC',
      'Manitoba': 'MB',
      'New Brunswick': 'NB',
      'Newfoundland and Labrador': 'NL',
      'Nova Scotia': 'NS',
      'Ontario': 'ON',
      'Prince Edward Island': 'PE',
      'Quebec': 'QC',
      'Saskatchewan': 'SK',
      'Northwest Territories': 'NT',
      'Nunavut': 'NU',
      'Yukon': 'YT'
    }
  },

  {
    code: 'AU', name: 'Australia',
    stateNameCodeMap: {
      'New South Wales': 'NSW',
      'Queensland': 'QLD',
      'South Australia': 'SA',
      'Tasmania': 'TAS',
      'Victoria': 'VIC',
      'Western Australia': 'WA',
      'Australian Capital Territory': 'ACT',
      'Northern Territory': 'NT'
    }
  },

  {
    code: 'NZ', name: 'NewZealand',
    stateNameCodeMap: {
      'Auckland': 'AUK',
      'Bay of Plenty': 'BOP',
      'Canterbury': 'CAN',
      'Chatham Islands': 'CIS',
      'Gisborne': 'GIS',
      'Hawke\'s Bay': 'HKB',
      'Manawatu-Wanganui': 'MWT',
      'Marlborough': 'MBH',
      'Nelson': 'NSN',
      'Northland': 'NTL',
      'Otago': 'OTA',
      'Southland': 'STL',
      'Taranaki': 'TAR',
      'Tasman': 'TAS',
      'Wellington': 'WGN',
      'West Coast': 'WCO'
    }
  },
  {
    code: 'IN', name: 'India', stateNameCodeMap: ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
      'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
      'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
      'Lakshadweep', 'Delhi', 'Puducherry', 'Ladakh', 'Lakshadweep', 'Jammu and Kashmir']
  },
  {
    code: 'ENG', name: 'England',
    stateNameCodeMap: {
      'East Midlands': 'EMID',
      'East of England': 'EENG',
      'London': 'LON',
      'North East': 'NE',
      'North West': 'NW',
      'South East': 'SE',
      'South West': 'SW',
      'West Midlands': 'WMID',
      'Yorkshire and the Humber': 'YH'
    }
  },

  {
    code: 'WAL', name: 'Wales',
    stateNameCodeMap: {
      'North Wales': 'NWA',
      'Mid Wales': 'MWA',
      'South Wales': 'SWA'
    }
  },

  {
    code: 'SCO', name: 'Scotland',
    stateCodes: ['CEN', 'HI', 'LOT', 'NE', 'SO', 'TAY'],
    stateNameCodeMap: {
      'Central Scotland': 'CEN',
      'Highlands and Islands': 'HI',
      'Lothian': 'LOT',
      'North East Scotland': 'NE',
      'South of Scotland': 'SO',
      'Tayside': 'TAY'
    }
  },

  {
    code: 'IRE', name: 'Ireland',
    stateCodes: ['ANT', 'ARM', 'LON', 'TYR', 'FER', 'DOW'],
    stateNameCodeMap: {
      'Antrim': 'ANT',
      'Armagh': 'ARM',
      'Londonderry': 'LON',
      'Tyrone': 'TYR',
      'Fermanagh': 'FER',
      'Down': 'DOW'
    }
  },

  {
    code: 'MX', name: 'Mexico',
    stateNameCodeMap: {
      'Aguascalientes': 'AGU',
      'Baja California': 'BC',
      'Baja California Sur': 'BCS',
      'Campeche': 'CAM',
      'Chiapas': 'CHP',
      'Chihuahua': 'CHH',
      'Coahuila': 'COA',
      'Colima': 'COL',
      'Durango': 'DUR',
      'Guanajuato': 'GTO',
      'Guerrero': 'GRO',
      'Hidalgo': 'HID',
      'Jalisco': 'JAL',
      'Mexico City': 'CDMX',
      'Mexico State': 'MEX',
      'Michoacán': 'MIC',
      'Morelos': 'MOR',
      'Nayarit': 'NAY',
      'Nuevo León': 'NL',
      'Oaxaca': 'OAX',
      'Puebla': 'PUE',
      'Querétaro': 'QUE',
      'Quintana Roo': 'QRO',
      'San Luis Potosí': 'SLP',
      'Sinaloa': 'SIN',
      'Sonora': 'SON',
      'Tabasco': 'TAB',
      'Tamaulipas': 'TAM',
      'Tlaxcala': 'TLX',
      'Veracruz': 'VER',
      'Yucatán': 'YUC',
      'Zacatecas': 'ZAC'
    }
  },
];

export const COUNTRY_STATECODE_MAP = {
  'US': ['AK', 'AL', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL',
    'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME',
    'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
    'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI',
    'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'],
  'USA': ['AK', 'AL', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL',
    'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME',
    'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
    'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI',
    'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'],
  'CA': ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'],
  'AU': ['NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'ACT', 'NT'],
  'NZ': ['AUK', 'BOP', 'CAN', 'CIS', 'GIS', 'HKB', 'MWT', 'MBH', 'NSN', 'NTL', 'OTA', 'STL', 'TAR', 'TAS', 'WGN', 'WCO'],
  'ENG': ['EMID', 'EENG', 'LON', 'NE', 'NW', 'SE', 'SW', 'WMID', 'YH'],
  'WAL': ['NWA', 'MWA', 'SWA'],
  'SCO': ['CEN', 'HI', 'LOT', 'NE', 'SO', 'TAY'],
  'IRE': ['ANT', 'ARM', 'LON', 'TYR', 'FER', 'DOW'],
  'MX': [
    'AGU', 'BC', 'BCS', 'CAM', 'CHP', 'CHH', 'COA', 'COL', 'DUR', 'GTO',
    'GRO', 'HID', 'JAL', 'CDMX', 'MEX', 'MIC', 'MOR', 'NAY', 'NL', 'OAX',
    'PUE', 'QUE', 'QRO', 'SLP', 'SIN', 'SON', 'TAB', 'TAM', 'TLX', 'VER',
    'YUC', 'ZAC'
  ]
};

export const COUNTRIES = ['USA', 'Canada'];

export const USStates = ['AK', 'AL', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL',
  'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME',
  'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
  'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI',
  'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

export const CAProvinces = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];

/* Chart Legend and Colors */
export const CHART_COLORS = {
  'active': '#1F8E3D',
  'expired': '#D92D20',
  'expiring': '#F5A623',
  'received': '#1F8E3D',
  'paid': '#1F8E3D',
  'paid_partial': '#1F8E3D',
  'received_PARTIAL': '#1F8E3D',
  'invoiced': '#2684FF', 
  'unpaid': '#D92D20',
  'expenses': '#1F8E3D',
  'charges': '#D92D20',
  'open': '#1264E7',
  'progress': '#8DD3FF',
  'covered': '#F5A623',
  'complete': '#2EB67D',
  'delivered': '#4BBC89',  
  'ACTIVE': '#1F8E3D',
  'EXPIRED': '#D92D20',
  'EXPIRING': '#F5A623',
  'RECEIVED': '#1F8E3D',
  'PAID': '#1F8E3D',
  'PAID_PARTIAL': '#1F8E3D',
  'RECEIVED_PARTIAL': '#1F8E3D',
  'INVOICED': '#2684FF', 
  'UNPAID': '#D92D20',
  'EXPENSES': '#1F8E3D',
  'CHARGES': '#D92D20',
  'OPEN': '#1264E7',
  'PROGRESS': '#8DD3FF',
  'COVERED': '#F5A623',
  'COMPLETE': '#2EB67D',
  'DELIVERED': '#4BBC89',
};